import { getSessionStore } from "@/utils/sessionStorage";

export function addTokenToUrl(url) {
  const accessToken = getSessionStore("access_token");
  if (!url || !accessToken || String(url).indexOf("access_token=") !== -1) {
    return url;
  }

  const urlString = String(url);
  if (urlString.indexOf("/#/") !== -1) {
    return url;
  }

  const hashIndex = urlString.indexOf("#");
  const beforeHash = hashIndex === -1 ? urlString : urlString.slice(0, hashIndex);
  const afterHash = hashIndex === -1 ? "" : urlString.slice(hashIndex);
  const separator = beforeHash.indexOf("?") === -1 ? "?" : "&";

  return beforeHash + separator + "access_token=" + encodeURIComponent(accessToken) + afterHash;
}

export function openWindowWithToken(url, target = "_blank", features = "") {
  window.open(addTokenToUrl(url), target, features);
}

export function getUploadHeaders() {
  const accessToken = getSessionStore("access_token");
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: "Bearer " + accessToken
  };
}
